// @flow
import type {Action} from '../actions/display';
import {MOBILESCROLLER_TOGGLE} from '../actions/display';

export type State = {
    +showMobileScroller: boolean
};

const initialState: State = {
    showMobileScroller: false
};

export default function reducer(
    state: State = initialState,
    action: Action
): State {
    if (action.type === MOBILESCROLLER_TOGGLE) {
        return {
            ...state,
            showMobileScroller: action.payload.showMobileScroller
        };
    }
    return state;
}
